<template>
  <span class="feed-delete-wrapper">
    <b-button
      v-b-tooltip.hover
      :title="buttonTitle"
      size="sm"
      variant="outline-danger"
      class="delete-btn"
      :disabled="deleting"
      @click="showModal = true"
    >
      <b-spinner
        v-if="deleting"
        small
      />
      <i
        v-else
        class="fa fa-trash"
      />
    </b-button>

    <BaseModal
      :show="showModal"
      :title="modalTitle"
      :processing="deleting"
      :show-confirm="false"
      :show-cancel="false"
      @update:show="showModal = $event"
    >
      <p class="fdb-body-text">
        {{ bodyText }}
      </p>

      <template #footer>
        <div class="fdb-footer">
          <template v-if="postType === 'check_out'">
            <button
              class="fdb-action-btn fdb-action-partial"
              :disabled="deleting"
              @click="confirm('check_out')"
            >
              <i class="fa fa-sign-out mr-2" />Solo la salida
            </button>
            <button
              class="fdb-action-btn fdb-action-full"
              :disabled="deleting"
              @click="confirm('both')"
            >
              <i class="fa fa-trash mr-2" />Entrada y salida
            </button>
          </template>
          <template v-else>
            <button
              class="fdb-action-btn fdb-action-full"
              :disabled="deleting"
              @click="confirm(postType === 'check_in' ? 'check_in' : 'post')"
            >
              <i class="fa fa-trash mr-2" />{{ confirmLabel }}
            </button>
          </template>
          <button
            class="fdb-cancel-btn"
            :disabled="deleting"
            @click="showModal = false"
          >
            Cancelar
          </button>
        </div>
      </template>
    </BaseModal>
  </span>
</template>

<script>
import { ref, computed } from '@vue/composition-api'
import BaseModal from '@/app/shared/components/BaseModal.vue'

export default {
  name: 'FeedDeleteButton',
  components: { BaseModal },
  props: {
    postType: {
      type: String,
      default: 'post' // 'post' | 'check_in' | 'check_out'
    },
    storeName: {
      type: String,
      default: ''
    },
    deleting: {
      type: Boolean,
      default: false
    }
  },
  setup (props, context) {
    const showModal = ref(false)

    const buttonTitle = computed(() =>
      props.postType === 'post' ? 'Eliminar publicación' : 'Eliminar registro'
    )

    const modalTitle = computed(() => {
      if (props.postType === 'check_in') return 'Eliminar entrada a tienda'
      if (props.postType === 'check_out') return 'Eliminar registro de visita'
      return 'Eliminar publicación'
    })

    const bodyText = computed(() => {
      const store = props.storeName || 'esta tienda'
      if (props.postType === 'check_out') {
        return `¿Qué deseas eliminar de la visita a ${store}?`
      }
      if (props.postType === 'check_in') {
        return `¿Confirmas que deseas eliminar la entrada a ${store}? Esta acción no se puede deshacer.`
      }
      return '¿Estás seguro que deseas eliminar esta publicación? Esta acción no se puede deshacer.'
    })

    const confirmLabel = computed(() =>
      props.postType === 'check_in' ? 'Eliminar entrada' : 'Eliminar'
    )

    const confirm = (target) => {
      showModal.value = false
      context.emit('delete', target)
    }

    return {
      showModal,
      buttonTitle,
      modalTitle,
      bodyText,
      confirmLabel,
      confirm
    }
  }
}
</script>

<style scoped>
.feed-delete-wrapper {
  display: contents;
}

/* Matches NewsCard .delete-btn */
.delete-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  padding: 0;
  border-radius: 6px;
  transition: all 0.2s ease;
  flex-shrink: 0;
}

.fdb-body-text {
  font-size: 0.875rem;
  color: #4a5568;
  margin-bottom: 0;
}

.fdb-footer {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  width: 100%;
}

.fdb-action-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  padding: 0.6rem 1.25rem;
  border-radius: 24px;
  font-size: 0.83rem;
  font-weight: 600;
  border: none;
  cursor: pointer;
  transition: opacity 0.15s ease;
}

.fdb-action-btn:disabled {
  opacity: 0.55;
  cursor: not-allowed;
}

.fdb-action-partial {
  background: #fff5f5;
  color: #c53030;
  border: 1px solid #feb2b2;
}

.fdb-action-partial:hover:not(:disabled) {
  background: #fed7d7;
}

.fdb-action-full {
  background: #e53e3e;
  color: #fff;
}

.fdb-action-full:hover:not(:disabled) {
  background: #c53030;
}

.fdb-cancel-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  padding: 0.55rem 1.25rem;
  border-radius: 24px;
  font-size: 0.83rem;
  font-weight: 500;
  background: transparent;
  border: 1px solid #e2e8f0;
  color: #718096;
  cursor: pointer;
  transition: background 0.15s ease;
}

.fdb-cancel-btn:hover:not(:disabled) {
  background: #f7fafc;
}

.fdb-cancel-btn:disabled {
  opacity: 0.55;
  cursor: not-allowed;
}
</style>



// WEBPACK FOOTER //
// src/app/news_feed/components/FeedDeleteButton.vue